<template>
    <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
            <router-link v-if="type == 'pf'" :to="{
                name: 'client_pf_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_pf_edit' ? 'active' : ''">
                Dados Pessoais </router-link>
        </li>
        <li class="nav-item">
            <router-link v-if="type == 'pj'" :to="{
                name: 'client_pj_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_pj_edit' ? 'active' : ''">
                Dados CNPJ </router-link>
        </li>
        <li class="nav-item">
            <router-link v-if="type == 'pj'" :to="{
                name: 'client_managing_partner',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_managing_partner' ? 'active' : ''">
                Sócio-Administrador </router-link>
        </li>
         <li class="nav-item" v-if="type == 'pj'">
             <router-link v-if="type == 'pj'" :to="{
                name: 'client_structure_corporate_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_structure_corporate_edit' ? 'active' : ''">
                Quadro Societário (QSA)  </router-link>
        </li>
        <li class="nav-item" >
             <router-link  :to="{
                name: 'client_certificate_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_certificate_edit' ? 'active' : ''">
                Certificados</router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{
                name: 'client_fiscal_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_fiscal_edit' ? 'active' : ''">
                Fiscal </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{
                name: 'client_access_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_access_edit' ? 'active' : ''">
                Acessos </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{
                name: 'client_service_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_service_edit' ? 'active' : ''">
                Contratos </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{
                name: 'client_status_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_status_edit' ? 'active' : ''">
                Status </router-link>
        </li>
         <li class="nav-item">
            <router-link :to="{
                name: 'client_file_office_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_file_office_edit' ? 'active' : ''">
                Arquivos escritório </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{
                name: 'client_access_system',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_access_system' ? 'active' : ''">
                Acessos plataforma </router-link>
        </li>
         <li class="nav-item">
            <router-link :to="{
                name: 'client_file_edit',
                params: { id: id }
            }" role="tab" data-toggle="tab" class="nav-link" :class="route == 'client_file_edit' ? 'active' : ''">
                Área do cliente </router-link>
        </li>

    </ul>
</template>

<script>
import { useRoute } from 'vue-router';

export default {
    data() {
        return {
            route: ''
        }
    },
    props: {
        id: String,
        client: String,
        type: String

    },

    mounted() {
        const route = useRoute();
        const currentRouteName = route.name;
        this.route = currentRouteName;
    }
}
</script>

<style></style>